import { CustomElement } from '@/utils';
import { bus } from '@/bus';

export default class AuthModal extends CustomElement {
  static component = 'b-auth-modal';
  dialog: HTMLDialogElement | null = null;
  closeButton: HTMLButtonElement | null = null;
  toggleButtons: (HTMLButtonElement|HTMLAnchorElement)[] = [];
  tabToggles: HTMLDialogElement[] = [];
  currentState = this.getAttribute('type') || 'login';
  dialogInner: HTMLDivElement | null = null;
  closeTimeout: any | null = null;
  successClose: HTMLDivElement | null = null;
  opened = false;

  init() {
    this.dialog = this.$('dialog');
    this.closeButton = this.$('close-button');
    this.dialogInner = this.$('dialog-inner');
    this.successClose = this.$('success-close');
    this.tabToggles = this.$$('auth-tab');

    if (this.hasAttribute('open')) {
      this.open();
    }

    if (this.successClose) {
      setTimeout(() => {
        this.close();
      }, 2000);
    }

    [
      'barba_leave',
      'cancel',
      'cartToggle',
      'menuToggle'
    ].forEach((event) => {
      bus.on(event as any, () => {
        this.close();
      });
    });

    this.dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
    });

    bus.on('click', (ev) => {
      const withinBoundaries = ev.composedPath().includes(this.dialogInner)
      // const withinBoundaries2 = this.toggleButtons.some((btn) => ev.composedPath().includes(btn))

      if (!withinBoundaries && this.opened) {
        this.close();
      }
    });

    this.tabToggles.forEach((tab) => {
      tab.addEventListener('click', () => {
        this.currentState = tab.dataset.authType || 'login';
        this.setAttribute('type', this.currentState);
      });
    });

    this.closeButton?.addEventListener('click', () => {
      this.close();
    });
  }

  open() {
    this.dialog.showModal();
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
    }

    requestAnimationFrame(() => {
      this.setAttribute('open', '');
      setTimeout(() => {
        this.opened = true;
      }, 1000);
    })

    const field = this.querySelector<HTMLInputElement>('input[name="email"]');
    if (field) {
      setTimeout(() => {
        field.focus();
      }, 1000);
    }
  }

  close() {
    this.removeAttribute('open');
    this.closeTimeout = setTimeout(() => {
      this.dialog.close()
      this.opened = false;
    }, 600);
  }
}
